<template>
<b-row class="ot-main-panel no-gutters">
    <b-col>
        <template v-if="loaded === false">
            <div class="OTloading">
                <div class="OTloader"></div>
            </div>
    </template>
        <b-row>
            <b-col>
                <b-row  class=" no-gutters OT-content-header">
                    <b-col cols="3">
                        <b-nav>
                            <b-nav-item @click.prevent="toggleFilters()">
                                <otif-icon :icon="filterGlobalAction.name" :label="filterGlobalAction.label"/>
                            </b-nav-item>
                        </b-nav>
                    </b-col>
                    <b-col class="OT-table-title">
                        <select-dashboard :selectedFacet="selected"/>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <b-row class="no-gutters">
            <b-col cols="3" v-if="showFilters" class="ot-table-filters  OT-LeftPanel OTfacetsgroup">
                <Filters/>
            </b-col>
            <b-col class="">
                <clusters/>
            </b-col>
        </b-row>
    </b-col>
</b-row>
</template>

<script>

import Clusters from './Clusters.vue';
import SelectDashboard from './SelectDashboard.vue'
import PageHeader from './PageHeader.vue';
import PageGlobalNav from './PageGlobalNav.vue';
import Filters from './filters/Filters.vue';
import Login from './Login.vue';

export default {
    
    computed: {
        clusterIds() {
            return this.$store.state.components.clusterIds;
        },

        cluster() {
            return this.$store.state.components.clusters;
        },

        connected() {
            return this.$store.state.socket.connected;
        },

        selected(){
            return "Activity Dashboard"
        },

        debug() {
            return process.env.NODE_ENV === 'development';
        },
    },

    components: {
        Clusters,
        SelectDashboard,
        Filters
    },

    data () {
        return {
            loaded: true,
            socketTimer: null,
            filterGlobalAction: {
                name: 'filter',
                label: 'Filters',
                callback: this.toggleFilters
            },
            showFilters : true
        }
    },

    methods: {
        toggleFilters() {
            if (this.showFilters === true) {
                this.showFilters = false;
            } else {
                this.showFilters = true;
            }
        },

        onLoggedIn: function() {
            this.$store.commit('LOGGED_IN');
        },

        subscribe() {
            this.$store.commit('components/CLEAR');
            this.$store.commit('facets/CLEAR');
            this.$socket.sendObj({
                subscribe: ['components', 'activityFacets','activities']
            });
        },

        defaultFacet() {
            this.$socket.sendObj({
                'filter': {
                    'queryPointId': "activities",
                    'facet':{
                        type  : 'condition',
                        field : 'TF_ID',
                        in    : ['LHD_ID']
                    }
                }
            });
        }

    },

    mounted() {
        this.$socket.connect();

        if (!this.connected) {
            var connectedInterval = setInterval(() => {
                if (this.connected) {
                    this.subscribe();
                    this.defaultFacet();
                    this.loaded = true;
                    clearInterval(connectedInterval);
                }
            }, 1000);
        } else {
            this.subscribe();
            this.defaultFacet();
            this.loaded = true;
        }
    },

    beforeRouteLeave(to, from, next) {
        this.$socket.sendObj({
            unSubscribe: ['components', 'activityFacets', 'activities']
        });
        this.$store.commit('components/CLEAR');
        if (to.hasOwnProperty('meta') && to.meta['ws'] !== true) {
            this.$socket.disconnect();
        }
        next();
    }
}

</script>
